var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button",class:{ 'loading': _vm.loading }},[(!_vm.loading)?[_vm._v(_vm._s(_vm.text))]:_c('div',{staticClass:"loader"},[_c('div'),_c('div'),_c('div'),_c('div')])],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MangalButton.vue?vue&type=template&id=5dcbecf6&
// module id = 761
// module chunks = 2